module.exports = __webpack_public_path__ + "img/follow-disabled.dc236fc7.svg";